import { passingModeStep, passingModeType } from '@/types';
import { z } from 'zod';

export const passingModeSchema = z.object({
  libelle: z.string().min(1, 'Le libelle ne doit pas être vide').max(250, 'Le libelle ne doit pas dépasser 250 caractères'),
  typeMarchersIds: z.array(z.number()).min(1, 'Le type de marché ne doit pas être vide'),
  type: z.nativeEnum(passingModeType, { message: 'La portée est requise' }).refine(val => val !== undefined && val !== null, {
    message: 'La portée est requise',
  }),

  etapes: z.nativeEnum(passingModeStep, { message: "Le mode d'execution est requise" }).refine(val => val !== undefined && val !== null, {
    message: 'Les étapes sont requises',
  }),
  restraint: z.boolean(),
});
